import Template from "common-components/dist/common/components/Template";

export default Template;
